@if (productFeatureList$ | async; as productFeatureList) { @if (productFeatureList.length > 0) {
<div class="container p-0 my-4">
  <h3 class="mb-3">{{ 'productDetails.features' | cxTranslate }}</h3>
  <table>
    @for (feature of productFeatureList; track feature) {
    <tr class="col-12 d-flex flex-wrap float-left p-0">
      @for (featureValue of feature?.featureValues; track featureValue) {
      <td class="col-12 float-left pl-0" [ngClass]="isHTML(featureValue?.value) ? 'col-lg-12 html-tag' : 'col-lg-6'">
        <ul class="d-flex flex-wrap mb-2 pl-4">
          <li>
            <div class="mr-3 mb-3 mb-lg-0 mb-md-0" [innerHtml]="featureValue?.value"></div>
          </li>
        </ul>
      </td>
      }
    </tr>
    }
  </table>
</div>
} }
